import React from 'react';

const CircleCILogo = props => (
  <svg width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <path
      d="M 11.875 16.03125 C 11.875 13.925781 13.601562 12.222656 15.722656 12.222656 C 17.847656 12.222656 19.570312 13.925781 19.570312 16.03125 C 19.570312 18.132812 17.847656 19.839844 15.722656 19.839844 C 13.601562 19.871094 11.875 18.132812 11.875 16.03125 Z M 15.722656 0 C 8.152344 0 1.816406 5.121094 0.03125 12.070312 C 0.03125 12.128906 0 12.160156 0 12.222656 C 0 12.648438 0.339844 12.984375 0.769531 12.984375 L 7.292969 12.984375 C 7.601562 12.984375 7.875 12.800781 8 12.527344 C 9.355469 9.628906 12.277344 7.617188 15.722656 7.617188 C 20.398438 7.617188 24.214844 11.398438 24.214844 16.03125 C 24.214844 20.664062 20.398438 24.441406 15.722656 24.441406 C 12.308594 24.441406 9.355469 22.429688 8 19.535156 C 7.875 19.261719 7.601562 19.078125 7.292969 19.078125 L 0.769531 19.078125 C 0.339844 19.078125 0 19.414062 0 19.839844 C 0 19.902344 0 19.929688 0.03125 19.992188 C 1.816406 26.941406 8.152344 32.0625 15.722656 32.0625 C 24.675781 32.0625 31.9375 24.867188 31.9375 16 C 31.9375 7.160156 24.675781 0 15.722656 0 Z M 15.722656 0"
      fill="#343434"
      id="surface1"
    />
  </svg>
);

export default CircleCILogo;



// WEBPACK FOOTER //
// ./src/javascripts/app/Webhooks/templates/logos/CircleCILogo.es6.js